<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import CustomSelectUser from '@/common/components/Form/CustomSelectUser'
import { mapGetters } from 'vuex'

export default {
	name: 'EditMain',
	components: {
		CustomSelect,
		CustomSelectUser
	},
	data () {
		return {
			submitted: false,
			subscriptionExist: false,
			subscription: {
				payment_type: null,
				client: null,
				advisor: null,
				has_paid_first_charge: false
			},
			paymentTypesList: [{name: 'automatic', label: 'Automatique'}]
		}
	},
	mounted () {
		this.subscription.advisor = this.advisor
		this.subscription.payment_type = this.paymentTypesList.filter((elem) => elem.name === 'automatic')[0]
		if (this.$route.name === 'MySubscriptionsEdit') {
			this.subscriptionExist = true
			const subscription = this.$store.getters.subscription(this.$route.params.id)
			this.subscription = {
				id: subscription.id,
				effect_date: this.$moment(subscription.effect_date, 'DD/MM/YYYY h:mm').format('YYYY-MM-DD'),
				payment_type: {name: subscription.payment_type, label: subscription.payment_type_label},
				client: subscription.user,
				advisor: subscription.advisor,
				has_paid_first_charge: subscription.has_paid_first_charge
			}
		}
	},
	methods: {
		createSubscription () {
			this.$store.dispatch('createSubscription', this.subscription)
			.then((result) => {
				this.subscriptionExist = true
				this.$router.push({ name: 'MySubscriptionsEdit', params: { id: result.id } })
			})
			.catch((e) => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				})
			})
		},
		patchSubscription () {
			this.$store.dispatch('patchSubscription', this.subscription)
			.then((result) => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'L\'opération a bien été modifiée',
					text: ''
				})
			}).catch((e) => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				})
			})
		},
		saveSubscription () {
			if (this.subscriptionExist) {
				this.patchSubscription()
			} else {
				this.createSubscription()
			}
		}
	},
	computed: {
		...mapGetters({
			advisor: 'user',
			clients: 'getClients'
		}),
		isFormValidated () {
			let effectDate = this.$moment(this.subscription.effect_date, 'YYYY-MM-DD')

			return effectDate.isValid()
		},
		isFormLoading () {
			return this.submitted
		},
		clientsFiltered () {
			return this.clients.filter((client) => typeof client.subscription === 'undefined' || !client.subscription)
		}
	}
}
</script>

<template lang="html">
	<form class="form-ui column default-form-ui" novalidate>
		<div class="ctn-input ctn-label no-border" v-selectUI :class="{error: errors.has('client')}">
			<label for="client">Client</label>
			<custom-select-user :items="clientsFiltered" v-model="subscription.client" :disabled="subscriptionExist"/>
		</div>
		<div v-if="errors.has('client')" class="error-message">{{ errors.first('client') }}</div>
		<div class="ctn-big-block">
			<div class="">
				<div class="ctn-input ctn-label" v-inputUI :class="{ error: errors.has('effect_date') }">
					<label for="effect_date">Date d'effet du contrat</label>
					<input v-validate="'required'" type="date" name="name" v-model="subscription.effect_date" :readonly="subscriptionExist && !!subscription.effect_date">
				</div>
			<div v-if="errors.has('effect_date')" class="error-message">{{ errors.first('effect_date') }}</div>

				<div class="check-container row start">
						<radio-box :value="subscription.has_paid_first_charge" @change="subscription.has_paid_first_charge=$event" :disabled="subscriptionExist"/>
						<div>&nbsp;Le client a déjà payé le premier honoraire (1.000 € hors taxes)</div>
				</div>
			</div>
		</div>
		<div class="ctn-cta row start" v-if="!subscriptionExist">
			<router-link :to="{ name: 'SubscriptionsTable' }" class="ctn-icon">
				<div class="btn btn-gold">Annuler</div>
			</router-link>
			<div class="btn btn-red" :class="{'btn-disabled': !isFormValidated || isFormLoading}" @click="saveSubscription">
				Enregistrer
			</div>
		</div>
	</form>
</template>

<style lang="css" scoped>
.default-form-ui .ctn-input input[type="date"] {
    padding: 0.5rem 0.8rem !important;
}
</style>



// WEBPACK FOOTER //
// Main.vue?f362b52a